<template>
  <section class="website-packages">
    <div class="container">
      <div class="header-group reveal">
        <h2 class="section-title">Our Website Packages</h2>
        <p class="section-subtitle">
          Professional websites that grow with your business
        </p>
        <div class="accent-line"></div>
      </div>

      <div class="packages-grid">
        <div class="package-card standard-plan reveal delay-1">
          <div class="package-header-inline">
            <svg
              class="header-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"
              />
              <path
                d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"
              />
            </svg>
            <h3>Single Page</h3>
          </div>

          <div class="package-badge-wrap">
            <span class="package-badge starter">Perfect Start</span>
          </div>

          <div class="pricing-section">
            <span class="price-label">Starting from</span>
            <div class="price-row">
              <span class="currency">$</span>
              <span class="amount">499</span>
            </div>
            <div class="hosting-price">+ $160/year hosting</div>
          </div>

          <ul class="features-list">
            <li>
              <div class="check-frame">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              Custom design
            </li>
            <li>
              <div class="check-frame">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              Mobile-responsive
            </li>
            <li>
              <div class="check-frame">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              SEO basics
            </li>
          </ul>

          <div class="timeline-tag">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            7-14 days delivery
          </div>

          <a href="mailto:contact@bizzento.com" class="package-cta"
            >Get Started</a
          >
        </div>

        <div class="package-card multi-page reveal delay-2">
          <div class="package-header-inline">
            <svg
              class="header-icon gold-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="12" y1="20" x2="12" y2="10" />
              <line x1="18" y1="20" x2="18" y2="4" />
              <line x1="6" y1="20" x2="6" y2="16" />
            </svg>
            <h3>Multi-Page</h3>
          </div>

          <div class="package-badge-wrap">
            <span class="package-badge premium">Most Popular</span>
          </div>

          <div class="pricing-section">
            <span class="price-label">Starting from</span>
            <div class="price-row">
              <span class="currency">$</span>
              <span class="amount">899</span>
            </div>
            <div class="hosting-price">+ $160/year hosting</div>
          </div>

          <ul class="features-list">
            <li>
              <div class="check-frame">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              Up to 5 pages
            </li>
            <li>
              <div class="check-frame">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              Advanced SEO
            </li>
            <li>
              <div class="check-frame">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              Analytics setup
            </li>
          </ul>

          <div class="timeline-tag">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            2-3 weeks delivery
          </div>

          <a href="mailto:contact@bizzento.com" class="package-cta featured"
            >Get Started</a
          >
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.website-packages {
  --sunlight-glow: #faefca;
  --dark-accent: #1a1a1a;
  --text-muted: #8e8a82;
  --gold-highlight: #bfa14d;
  --border-light: #e2e2e2; /* Added for standard plan */

  padding: 100px 24px;
  background: white;
  color: var(--dark-accent);
}

.container {
  max-width: 1100px;
  margin: 0 auto;
}

.header-group {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: clamp(2rem, 4vw, 2.8rem);
  font-weight: 800;
  margin-bottom: 12px;
}

.accent-line {
  width: 50px;
  height: 4px;
  background: var(--gold-highlight);
  margin: 20px auto 0;
  border-radius: 10px;
}

.packages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  justify-content: center;
}

/* Base Card Styling */
.package-card {
  background: white;
  border-radius: 32px;
  padding: 40px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* Added Border for Standard Plan */
.standard-plan {
  border: 2px solid var(--border-light);
}

.standard-plan:hover {
  transform: translateY(-8px);
  border-color: #cccccc; /* Slightly darkens on hover */
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.05);
}

/* Gold Border for Multi-Page */
.multi-page {
  border: 2px solid var(--gold-highlight);
  background: #fffdf9;
  position: relative;
}

.multi-page:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(191, 161, 77, 0.15);
}

.package-header-inline {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 8px;
}

.header-icon {
  color: var(--text-muted);
}

.gold-svg {
  color: var(--gold-highlight);
}

h3 {
  font-size: 1.5rem;
  font-weight: 800;
  margin: 0;
}

.package-badge-wrap {
  margin-bottom: 24px;
}

.package-badge {
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 6px;
}

.starter {
  background: #f0fdf4;
  color: #166534;
}
.premium {
  background: var(--sunlight-glow);
  color: #856404;
}

.pricing-section {
  width: 100%;
  margin-bottom: 30px;
  padding: 24px 0;
  border-top: 1px solid #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.price-row {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  line-height: 1;
  margin: 8px 0;
}

.currency {
  font-size: 1.9rem;
  font-weight: 700;
  margin-right: 2px;
  margin-top: 6px;
  transform: translateY(13px);
}

.amount {
  font-size: 4rem;
  font-weight: 800;
  letter-spacing: -2px;
}

.price-label {
  font-size: 0.8rem;
  color: var(--text-muted);
  text-transform: uppercase;
  font-weight: 700;
}

.hosting-price {
  font-size: 0.9rem;
  color: var(--text-muted);
}

.features-list {
  list-style: none;
  padding: 0;
  margin: 0 0 30px 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.features-list li {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 0.95rem;
}

.check-frame {
  width: 18px;
  height: 18px;
  background: var(--sunlight-glow);
  color: var(--gold-highlight);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex-shrink: 0;
}

.timeline-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--text-muted);
  margin-bottom: 24px;
}

.package-cta {
  width: 100%;
  max-width: 240px;
  text-align: center;
  padding: 16px;
  background: var(--dark-accent);
  color: white;
  border-radius: 100px;
  text-decoration: none;
  font-weight: 700;
  transition: all 0.2s ease;
}

.package-cta.featured {
  background: var(--gold-highlight);
}

.package-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  pointer: cursor;
}
</style>
